import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Rafraîchit automatiquement l'access token (24h) via le refresh token (7j)
// quand une requête échoue en 401, puis rejoue la requête une seule fois.
const NO_REFRESH_URLS = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshPromise = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error.config;
    const status = error.response?.status;
    const skip = !config || config._retried || NO_REFRESH_URLS.some((u) => config.url?.includes(u));
    if (status === 401 && !skip) {
      config._retried = true;
      try {
        refreshPromise = refreshPromise || api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        await refreshPromise;
        return api(config);
      } catch {
        // refresh token expiré : on laisse l'erreur 401 d'origine remonter
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
